import { Brand } from '../../../shared/interfaces/brand';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { CreateComponentModel } from '@app/shared/model/create-component-model';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.less'],
})
export class CreateComponent extends CreateComponentModel implements OnInit {
  @ViewChild('formComponent') formComponent: any;
  record: any;
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {}

  getCreateSuccessfullyMessage(record: Brand): string {
    return `New record with id: ${record.Id} - was created successuflly.`;
  }
  recordDetailsLoaded(): void {
    setTimeout(() => {
      this.formComponent.recordLoaded();
    }, 0);
  }
  override submit(record?: any): void {
    super.submit(record);
  }

  cleanRecord(record: any) : any {
    return this.formComponent.cleanRecord(record);
  }

  beforeSubmit() {
    return this.formComponent.beforeSubmit();
  }
  afterSubmit(record: any): void {
    if (
      this.formComponent.afterSubmit != null &&
      typeof this.formComponent.afterSubmit == 'function'
    ) {
      this.formComponent.afterSubmit(record);
    }
  }
}
